import Swiper from 'swiper';
import {Autoplay, Navigation, Pagination} from 'swiper/modules';
import {getOptionsFromJsonString} from "../../../default/global/js/utilities/options";

export function initItemlistSlider(query = document.querySelectorAll('.itemboxList.previewListType--1.swiper'),options = {}) {
    let defaultOptions = {
        breakpointItems: {
            xxxs: 1.15,
            xxs: 1.5,
            xs: 2,
            sm: 2.2,
            md: 3,
            lg: 3.5,
            xlg: 4
        }
    }

    defaultOptions = {...defaultOptions, ...options};

    for (let itemlist of query) {

        let options = getOptionsFromJsonString(itemlist.getAttribute('data-options'), defaultOptions);
        let childrenCount = itemlist.querySelectorAll('.swiper-wrapper > *').length;
        let loop = false;

        if(itemlist.closest(".col-md-8")){
            options.breakpointItems.md = 3;
            options.breakpointItems.lg = 3;
            options.breakpointItems.xlg = 3;
        }

        let breakpoints = {
            xxxs: {
                items: options.breakpointItems.xxxs,
                autoplay: childrenCount > Math.ceil(options.breakpointItems.xxxs),
            },
            xxs: {
                items: options.breakpointItems.xxs,
                autoplay: childrenCount > Math.ceil(options.breakpointItems.xxs),
            },
            xs: {
                items: options.breakpointItems.xs,
                autoplay: childrenCount > Math.ceil(options.breakpointItems.xs),
            },
            sm: {
                items: options.breakpointItems.sm,
                autoplay: childrenCount > Math.ceil(options.breakpointItems.sm),
            },
            md: {
                items: options.breakpointItems.md,
                autoplay: childrenCount > Math.ceil(options.breakpointItems.md),
            },
            lg: {
                items: options.breakpointItems.lg,
                autoplay: childrenCount > Math.ceil(options.breakpointItems.lg),
            },
            xlg: {
                items: options.breakpointItems.xlg,
                autoplay: childrenCount > Math.ceil(options.breakpointItems.xlg),
            }
        }

        //deactivate autoplay
        breakpoints.xxxs.autoplay = true;
        breakpoints.xxs.autoplay = true;
        breakpoints.xs.autoplay = false;
        breakpoints.sm.autoplay = false;
        breakpoints.md.autoplay = false;
        breakpoints.lg.autoplay = false;
        breakpoints.xlg.autoplay = false;

        if (window.outerWidth > GLOBALS.gridBreakpoints.sm && childrenCount > breakpoints.sm.items) {
            loop = true;
        }

        if (window.outerWidth > GLOBALS.gridBreakpoints.md && childrenCount > breakpoints.md.items) {
            loop = true;
        }

        if (window.outerWidth > GLOBALS.gridBreakpoints.xlg && childrenCount > breakpoints.xlg.items) {
            loop = true;
        }

        Swiper.use([Autoplay, Navigation, Pagination]);
        new Swiper(itemlist, {
            loop: loop,
            speed: 300,
            spaceBetween: 0,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerGroup: 1,
            autoHeight: false,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: itemlist.querySelector('.swiper-button-next'),
                prevEl: itemlist.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: breakpoints.xxxs.items,
                    autoplay: {
                        enabled: breakpoints.xxxs.autoplay
                    }
                },
                420: {
                    slidesPerView: breakpoints.xxs.items,
                    autoplay: {
                        enabled: breakpoints.xxs.autoplay
                    }
                },
                640: {
                    slidesPerView: breakpoints.xs.items,
                    autoplay: {
                        enabled: breakpoints.xs.autoplay
                    }
                },
                768: {
                    slidesPerView: breakpoints.sm.items,
                    autoplay: {
                        enabled: breakpoints.sm.autoplay
                    }
                },
                1024: {
                    slidesPerView: breakpoints.md.items,
                    autoplay: {
                        enabled: breakpoints.md.autoplay
                    }
                },
                1250: {
                    slidesPerView: breakpoints.lg.items,
                    autoplay: {
                        enabled: breakpoints.lg.autoplay
                    }
                },
                1540: {
                    slidesPerView: breakpoints.xlg.items,
                    autoplay: {
                        enabled: breakpoints.xlg.autoplay
                    }
                }
            }
        });
    }
}

export function initItemlistSliderGrid(query = document.querySelectorAll('.itemboxList.previewListType--2.swiper'), options = {}) {
    let defaultOptions = {
        breakpointItems: {
            xs: 1.5,
        }
    };

    defaultOptions = { ...defaultOptions, ...options };

    const breakpoint = window.matchMedia('(min-width: 768px)');
    let swiperInstances = new Map();

    function initSwiperForElement(itemlist) {
        const options = getOptionsFromJsonString(itemlist.getAttribute('data-options'), defaultOptions);
        const childrenCount = itemlist.querySelectorAll('.swiper-wrapper > *').length;

        const breakpoints = {
            xs: {
                items: options.breakpointItems.xs,
                autoplay: true
            }
        };

        const swiper = new Swiper(itemlist, {
            speed: 500,
            spaceBetween: 0,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            autoHeight: false,
            autoplay: {
                enabled: true,
            },
            navigation: {
                nextEl: itemlist.querySelector('.swiper-button-next'),
                prevEl: itemlist.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: breakpoints.xs.items,
                    slidesPerGroup: Math.floor(breakpoints.xs.items),
                    autoplay: {
                        enabled: breakpoints.xs.autoplay
                    }
                }
            }
        });

        swiperInstances.set(itemlist, swiper);
    }

    function destroySwiperForElement(itemlist) {
        const swiper = swiperInstances.get(itemlist);
        if (swiper) {
            swiper.destroy(true, true);
            swiperInstances.delete(itemlist);
        }
    }

    function toggleSwipers() {
        for (let itemlist of query) {
            if (breakpoint.matches) {
                destroySwiperForElement(itemlist);
            } else {
                if (!swiperInstances.has(itemlist)) {
                    initSwiperForElement(itemlist);
                }
            }
        }
    }

    toggleSwipers();
    breakpoint.addEventListener('change', toggleSwipers);
}
